import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { json, Link, useLoaderData, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Pagination } from "swiper";
import loading from '../assets/loading-animation.gif'
import { FaGithub, FaGlobe, FaSlackHash } from "react-icons/fa";

const Details = () => {
  let { id } = useParams();

  const { isLoading, data } = useQuery({
    queryKey: ["project"],
    queryFn: async () => {
      const res = await fetch(`https://amit-portfolio-server.vercel.app/project/${id}`);
      const data = await res.json();
      return data;
    },
  });

  if (isLoading) return <img src={loading} alt=''/>;

  return (
    <div className="w-1/2 mx-auto">
      <div>

        <div className="text-center">
            <Swiper
              effect={"coverflow"}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={"auto"}
              coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              pagination={true}
              modules={[EffectCoverflow, Pagination]}
              className="mySwiper"
            >
              {
                data.images.map((project,i) => <SwiperSlide  key={i}>
                 
                    
                      <img
                        src={project}
                        alt=""
                        className="w-full h-96 object-scale-down"
                      />
                   
                </SwiperSlide>)
              }
              
              
            </Swiper>
          </div>
      </div>
      <div>
      <h2 className="text-3xl text-red-500">{data.title}</h2>
      <h5 className="text-md font-bold text-red-900">Description :</h5>
      <p className="text-white">
        {data.details}
      </p>
      <h5 className="text-md font-bold text-red-900">Key Features :</h5>
      <ul className="ml-4">
        
        {
          data.points.map((point,i) => <li key={i} className="text-white"><FaSlackHash className="text-red-500"></FaSlackHash> {point}</li>
          )
          
          
        }
        
      </ul>
      <h5 className="text-md font-bold text-red-900">Technology :</h5>
      <p>
        {
        data.technology.map((tech,i) => <span key={i} className="text-white">{tech} , </span> 
      )}
        </p>
        <div className="mt-3">
          <a href={data.links[0].live_link} className="inline-block text-red-500 px-4 py-1 mr-5 border border-red-500 rounded-sm hover:bg-red-500 hover:text-white hover:transition-all">
            <span><FaGlobe className="inline"></FaGlobe> Live Site</span></a>
          <a href={data.links[0].client_link} className="inline-block text-red-500 px-4 py-1 mr-5 border border-red-500 rounded-sm hover:bg-red-500 hover:text-white hover:transition-all"> <span><FaGithub className="inline"></FaGithub> Client Repo</span></a>
          <a href={data.links[0].server_link} className="inline-block text-red-500 px-4 py-1 mr-5 border border-red-500 rounded-sm hover:bg-red-500 hover:text-white hover:transition-all"><FaGithub className="inline"></FaGithub> <span>Server Repo</span></a>
          

        
        </div>
      </div>
      
    </div>
  );
};

export default Details;
